import React from "react";
import "./category-header.scss";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";

export interface ICategoryHeader {
  breadcrum: string;
  title: string;
}

const CategoryHeader = (props: ICategoryHeader) => {
  const { breadcrum, title } = props;
  const compClass = "o-categoryHeader";

  return (
    <section className={compClass}>
      <div className={`${compClass}__breadcrums`}>
        <Breadcrumb content={breadcrum} />
      </div>
      <h1 className={`${compClass}__title`}>{title}</h1>
    </section>
  );
};

export default CategoryHeader;
